<template>
    <div class="lendMoney-wrap" v-if="showList">
        <h6 class="lendMoney-title ta-c"><span>——</span> 其他借款方式 <span>——</span></h6>
        <ul class="lendMoney-list">
            <li class="bank-item ta-c" v-for="(item,index) in items"
                v-if="index<(showAll?itemLength:showDefaultLength)" :clstag="item.clstag">
                <a :href="getBankUrl(item.url)">
                    <div class="bank-title"><img class="bank-logo" :src="item.productLogo"><span
                            class="font-bold">{{item.productName}}</span>
                    </div>
                    <div class="bank-subtitle">{{item.productLabel}}</div>
                    <div class="bank-range"><span>¥ </span>{{replaceZh(item.availableAmount || item.amountRange)}}</div>
                    <div class="bank-rate">综合费率(日) {{item.rate}}</div>
                </a>
            </li>
        </ul>
        <div class="more-btn ta-c" v-if="itemLength>2" v-on:click="changeAll">
            <span v-if="showAll">收起<span :class="{flip:showAll,btnArrow:true}"></span></span>
            <span v-else>查看更多<span :class="{flip:showAll,btnArrow:true}"></span></span>
        </div>
    </div>
</template>

<script type="text/javascript">
    import toThousand from "../tools/toThousands";
    import jm from "../tools/jm"

    export default {
        name: 'lendMoney',
        props: {
            bankData: {
                type: Object,
                default: function () {
                    return {
                        isLogin: false,
                        lendmoneyList: [
                            /*{
                             productLogo: "",
                             productName: "测试银行",
                             productLabel: "测试label",
                             availableAmount: "1000元",
                             rate: "0.3-0.5",
                             amountRange: "2000元",
                             url: "http://www.jd.com"
                             }*/
                        ]
                    }
                }
            }
        },
        data: function () {
            return {
                showList: true,
                showDefaultLength: 2,
                showAll: false
            }
        },
        computed: {
            items: function () {
                var lendMoneyList = this.bankData.lendmoneyList;
                if(lendMoneyList){
                    var reg = new RegExp("id=([^&]*)(&|$)", "i");
                    for (var i = 0; i < lendMoneyList.length; i++) {
                        var id = lendMoneyList[i].url.match(reg);
                        lendMoneyList[i].clstag = "pageclick|keycount|lendcard2017|"+id[1]+"|url";
                    }
                }
                return lendMoneyList
            },
            itemLength: function () {
                if (this.bankData.lendmoneyList) {
                    return this.bankData.lendmoneyList.length;
                } else {
                    this.showList = false;
                    return 0
                }
            }
        },
        methods: {
            getBankUrl: function (url) {
                if (this.bankData.isLogin) {
                    return url
                } else {
                    var _url = "//passport.m.jd.com/user/login.action?v=1&returnurl=" + encodeURIComponent(window.location.href);
                    return _url
                }
            },
            changeAll: function (event) {
                this.showAll = !this.showAll;
            },
            replaceZh: function (string) {
                return string.replace("元", "")
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss">
    $gold: #dab273;
    .lendMoney-title { color: #666; font-size: 0.14rem; margin-bottom: 0.1rem;
        span { color: #ccc; }
        }
    .lendMoney-wrap { margin-top: 0.2rem; }
    .bank-item { width: 3.75rem; height: 2.22rem; background: url("../assets/css-img/bank-card.png"); background-size: contain; margin-bottom: -0.12rem; line-height: 1; }
    .bank-logo { height: 0.18rem; margin-right: 0.05rem; position: relative; top: -0.01rem; }
    .bank-title { font-size: 0.16rem; vertical-align: bottom; color: #333; padding-top: 0.33rem; }
    .bank-subtitle { font-size: 0.14rem; color: #333; margin-top: 0.1rem; }
    .bank-range { font-size: 0.4rem; color: $gold; font-family: "DIN-Bold"; margin-top: 0.15rem;
        span { font-size: 0.2rem; }
        }
    .bank-rate { margin-top: 0.1rem; color: #999; font-size: 0.14rem; }
    .more-btn { widrh: 3.75rem; height: 0.77rem; background: url("../assets/css-img/more-btn.png"); background-size: contain; font-size: 0.14rem; color: #c1872b; position: relative;
        span { position: absolute; left: 50%; transform: translateX(-50%); top: 0.17rem; }
        .btnArrow { display: block; width: 0.07rem; height: 0.05rem; background: url("../assets/css-img/btn-arrow.png") no-repeat center center; background-size: contain; position: absolute; left: 100%; top: 50%; margin-top: -0.015rem; margin-left: 0.1rem; }
        .flip { transform: rotate(180deg); }
        }
</style>



// WEBPACK FOOTER //
// LendMoney.vue?20defb45